import TransducerView from "./TransducerView";

export default TransducerView;